const updateIndustryMaxValues = (state, payload) => {
  state.pIPageMaxPercent = payload.maxPercentage;
  state.pIPageMaxDecimal = payload.maxDecimal;
};
const updatePIChartData = (state, payload) => {
  state.performanceIndexChartData = payload;
};
const updatePIDisplayMode = (state, payload) => {
  state.pIDisplayMode = payload;
};
const updatePILegend = (state, payload) => {
  state.pILegendData = payload;
};
const updateTableSortColumn = (state, payload) => {
  state.tableSortColumn = payload;
};

export default {
  updateIndustryMaxValues,
  updatePIChartData,
  updatePIDisplayMode,
  updatePILegend,
  updateTableSortColumn,
};
